import { createSelector } from 'reselect';

const selectLeadDayValue = (state) => state.setup_advanced_user_lead_day_values;

export const selectLeadDayValues = createSelector(
  [selectLeadDayValue],
  (leadDayValue) => leadDayValue.lead_day_values,
);
